import { defineElement, FC, useProp } from '@atomify/hooks';
import { h } from '@atomify/jsx';
import { Container } from '@bpd-library/components';

import { BPDFunctionalSvg } from '../svg/svg';

const BPDBackLink: FC = () => {
    const [text] = useProp<string>('text', '');
    const [url] = useProp<string>('url', '');
    const [backToHousingOverview] = useProp<boolean | null>('backToHousingOverview', null);

    function goBack() {
        window.history.back();
    }

    function goToHousingOverview() {
        const { referrer } = document;
        const { areaHouseOverviewUrl } = window.__ENVIRONMENT_DETAILS__;

        if (isHousingOverviewUrl(referrer)) {
            window.location.href = referrer;
        } else {
            window.location.href = `${window.location.origin}${areaHouseOverviewUrl}`;
        }
    }

    function isHousingOverviewUrl(url: string): boolean {
        const { pathname } = new URL(url);
        const { areaHouseOverviewUrl, districtHouseOverviewUrl } = window.__ENVIRONMENT_DETAILS__;

        const districtHouseOverviewUrlArray = Object.values(districtHouseOverviewUrl);
        const housingOverviewUrls = [areaHouseOverviewUrl, ...districtHouseOverviewUrlArray];

        return !!housingOverviewUrls.find((housingOverviewUrl) => pathname === housingOverviewUrl);
    }

    const Element = url ? 'a' : 'button';
    const backBehavior = url
        ? { href: url }
        : { onClick: backToHousingOverview ? goToHousingOverview : goBack };

    return (
        <Container extraClass="c-back-link">
            <Element class="back-link__button u-flex u-flex-middle" {...backBehavior}>
                <div class="back-link__icon">
                    <BPDFunctionalSvg name="arrow-chevron-right" />
                </div>

                <div class="back-link__label u-chip">{text}</div>
            </Element>
        </Container>
    );
};

BPDBackLink.props = {
    text: {
        type: String,
    },
    url: {
        type: String,
    },
    backToHousingOverview: {
        type: Boolean,
    },
};

defineElement('bpd-back-link', BPDBackLink);
